"use client";

import slugify from "slugify";
import Link from "next/link";
import { toast } from "sonner";
import { PropsWithChildren } from "react";
import { getTextContent } from "@/helpers/getTextContent";
import HashtagIcon from "@/components/core/icons/HashtagIcon";
import clsx from "clsx";

interface BlockHashtagHeadingProps extends PropsWithChildren {
  Comp: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  id?: string;
}

export default function BlockHashtagHeading({
  children,
  Comp,
  id,
}: BlockHashtagHeadingProps) {
  const hashtag = id || slugify(getTextContent(children).toLowerCase(), {strict: true});

  async function copyHashtag(hashtag: String) {
    const href = window.location.href;
    const computedHref = `${href?.split("#")[0]}#${hashtag}`;
    await navigator.clipboard.writeText(computedHref);
    toast.success("Copied link to clipboard");
  }

  return (
    <Comp
      id={hashtag}
      onClick={() => copyHashtag(hashtag)}
      className="block md:flex"
    >
      <Link aria-label="Link to section" className="[&_strong]:font-medium!" href={"#" + hashtag}>
        <HashtagIcon
          className={clsx(
            "inline -mt-1 cursor-pointer font-medium text-red mr-1",
            Comp === "h2" || Comp === "h1"
              ? "w-6 h-6 md:-ml-7"
              : "w-4 h-4 md:-ml-5"
          )}
        />
        {children}
      </Link>
    </Comp>
  );
}
